import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["accept"]
const _hoisted_2 = {
  key: 0,
  class: "gfu-field-media__img-wrapper"
}
const _hoisted_3 = { class: "gfu-field-media__actions" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "gfu-field-media__input-title" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dropdown_link = _resolveComponent("dropdown-link")
  const _component_dropdown_group = _resolveComponent("dropdown-group")
  const _component_drop_area = _resolveComponent("drop-area")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createBlock(_component_field, _normalizeProps(_guardReactiveProps({..._ctx.$attrs, ..._ctx.$props})), _createSlots({
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(['gfu-field-media', $props.mediaFieldClass]),
        "data-qa": "image-field"
      }, [
        _createElementVNode("input", {
          ref: "fileInput",
          class: "gfu-field-media__input",
          type: "file",
          accept: $options.acceptedFormats,
          onChange: _cache[0] || (_cache[0] = (...args) => ($options.onFileInputChange && $options.onFileInputChange(...args))),
          "data-qa": "image-field-input"
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1),
        ($props.thumbUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_drop_area, {
                enabled: $props.allowDrop && !_ctx.readOnly,
                name: _ctx.name,
                tabindex: "0",
                onDrop: $options.uploadMedia
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_dropdown_group, {
                      ref: "dropdown",
                      fixed: false,
                      "collapse-on-scroll": true
                    }, {
                      default: _withCtx(() => [
                        (($props.uploadApiAction || $props.uploadApiFunction) && !_ctx.readOnly)
                          ? (_openBlock(), _createBlock(_component_dropdown_link, {
                              key: 0,
                              icon: "sync",
                              label: "Replace",
                              onClick: $options.selectFileForUpload,
                              "data-qa": "image-field-button:Replace"
                            }, null, 8 /* PROPS */, ["onClick"]))
                          : _createCommentVNode("v-if", true),
                        ($props.isCropEnabled && !_ctx.readOnly)
                          ? (_openBlock(), _createBlock(_component_dropdown_link, {
                              key: 1,
                              icon: "crop",
                              label: "Crop",
                              onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('crop-requested'))),
                              "data-qa": "image-field-button:Crop"
                            }))
                          : _createCommentVNode("v-if", true),
                        ($props.allowDelete && !_ctx.readOnly)
                          ? (_openBlock(), _createBlock(_component_dropdown_link, {
                              key: 2,
                              icon: "trash-alt",
                              label: "Delete",
                              onClick: $options.deleteMedia,
                              "data-qa": "image-field-button:Delete"
                            }, null, 8 /* PROPS */, ["onClick"]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */)
                  ]),
                  (!$options.isVideoType)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: _normalizeClass(['gfu-field-media__image', $props.mediaClass]),
                        src: $data.cacheLessThumbUrl,
                        draggable: "false",
                        alt: $props.displayName,
                        "data-qa": "image-field-image"
                      }, null, 10 /* CLASS, PROPS */, _hoisted_4))
                    : (_openBlock(), _createElementBlock("video", {
                        key: 1,
                        class: _normalizeClass(['gfu-field-media__image', $props.mediaClass]),
                        src: $data.cacheLessThumbUrl,
                        draggable: "false",
                        alt: $props.displayName,
                        controls: "",
                        preload: "metadata",
                        controlslist: "nodownload nofullscreen noremoteplayback",
                        "disable-picture-in-picture": "",
                        muted: "",
                        "data-qa": "image-field-video"
                      }, null, 10 /* CLASS, PROPS */, _hoisted_5))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["enabled", "name", "onDrop"])
            ]))
          : _createCommentVNode("v-if", true),
        (($props.uploadApiAction || $props.uploadApiFunction) && !$props.thumbUrl)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              ($props.allowDrop)
                ? (_openBlock(), _createBlock(_component_drop_area, {
                    key: 0,
                    enabled: $props.allowDrop && !_ctx.readOnly,
                    preview: false,
                    name: _ctx.name,
                    tabindex: "0",
                    class: "_flex _flexcol _jc-c _ai-c",
                    onDrop: $options.uploadMedia,
                    onClick: $options.selectFileForUpload
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.readOnly)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("a", {
                              href: "",
                              class: "gfu-btn gfu-btn--circle gfu-btn--circle-big gfu-btn--primary",
                              onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.selectFileForUpload && $options.selectFileForUpload(...args)), ["stop","prevent"]))
                            }, [
                              _createVNode(_component_base_icon, { name: "upload" })
                            ]),
                            _createElementVNode("span", _hoisted_6, _toDisplayString($options.title), 1 /* TEXT */),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.descriptionItems, (item) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: item,
                                class: "gfu-field-media__input-description"
                              }, _toDisplayString(item), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ], 64 /* STABLE_FRAGMENT */))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("a", {
                              href: "#",
                              disabled: "",
                              class: "gfu-btn gfu-btn--circle gfu-btn--circle-big gfu-btn--gray",
                              onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => ($options.selectFileForUpload && $options.selectFileForUpload(...args)), ["stop","prevent"]))
                            }, [
                              _createVNode(_component_base_icon, { name: "ban" })
                            ]),
                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "gfu-field-media__input-title gfu-field-media__input-title--disabled" }, "This field is disabled.", -1 /* CACHED */))
                          ], 64 /* STABLE_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["enabled", "name", "onDrop", "onClick"]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_progress_overlay, { visible: $data.isProcessing }, null, 8 /* PROPS */, ["visible"])
      ], 2 /* CLASS */)
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (_ctx.$slots['field-description'])
      ? {
          name: "field-description",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "field-description")
          ]),
          key: "0"
        }
      : undefined
  ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
}